import React, { Component } from "react";
import { navigate } from "gatsby";

import Swiper from "../../../components/swiper";
import ModuleWrapper from "../../../components/moduleWrapper";
import Image from "../../../components/image";
import Icon from "../../../components/icon";
import SearchTopBar from "../components/searchTopBar";
import LodgingTabs from "../components/lodgingTabs";
import LodgingCell from "../supplierPage/components/lodgingCell";
import Description from "../components/description";
import Seo from "../../../components/seo";
import SearchModal from "../components/searchModal";
import SearchForm from "../supplierPage/components/form/searchForm";
import { getLanguageField } from "../../../utils/language";
import { differenceInDays } from "../../../utils/datefns";
import { getQuery } from "../../../utils/query";
import getAvailability, { addLodgingToCart, parseFormFromQueryString, getCalendarAvailability, processForm, getSearchFormConfiguration } from "../../../services/lodging";
import Modal from "../components/modal";
import Amenities from "../supplierPage/components/amenities";
import Location from "../supplierPage/components/location";
import Policies from "../supplierPage/components/policies";
import GalleryModal from "../components/galleryModal";
import provisionalModuleDataBasedOnLanguage from "../supplierPage/provisionalModuleDataBasedOnLanguage";
import Breadcrumbs from "../../../components/breadCrumbs";
import ServicesModal from "../../package/components/servicesModal";
import { getSupplierSlug } from "../../../../build-helpers/create-page";
import RoomSummarySelection from "../../../components/roomSummarySelection";
import Spinner from "../../../components/spinner";
import { gtmFunction } from "../../../utils/gtm";
import { isRunTime } from "../../../utils/isRunTime";

import HeadStyling from "src/layouts/components/styling/head.styling";
import UpsellingModal from "src/components/upselling/upsellingModal";
import { getImageDeliveryUrl } from "src/utils/imageDelivery";

export default class ProductPage extends Component {
  state = {
    loading: false,
    currentTab: 0,
    form: {
      arrivalDate: null,
      departureDate: null,
      guests: []
    },
    searchDrawer: false,
    photosModal: false,
    prices: {},
    modalAddToCart: "",
    galleryModal: false,
    selectedMeal: 0,
    numberOfRooms: undefined,
    currentRoom: undefined,
    selectedOffer: {},
    availability: [],
    servicesModalProduct: {},
    noSearch: true,
    errorOnSearch: false
  }

  supplier = this.props.pageContext.supplier.products && this.props.pageContext.supplier.products[0] && this.props.pageContext.supplier.products[0].product_uuid  ? this.props.pageContext.supplier.products[0].product_uuid : this.props.pageContext.supplier;
  upselling = this.supplier.upselling || this.props.pageContext.supplier.upselling
  language = this.props.pageContext.language;
  defaultLanguage = this.props.pageContext.defaultLanguage;
  format = "eu";

  colors = {
    formPrimaryColor: this.props.pageContext.supplier?.secondary_color?.value,
    formSecondaryColor: this.props.pageContext.supplier?.primary_color?.value
  }
  primaryButtonStyle = `bg-[color:var(--primaryColor)] border-none text-[color:var(--secondaryColor)]`
  secondaryButtonStyle = `bg-white border-[color:var(--secondaryColor)] text-[color:var(--primaryColor)]`

  moduleData = provisionalModuleDataBasedOnLanguage(this.language)

  toggleSearchDrawer = () => {
    this.setState({ searchDrawer: !this.state.searchDrawer })
  }

  changeTab = (tab) => {
    this.setState({ currentTab: tab });
  }

  getStickyOffset = () => {
    const toolbar = document.getElementById('toolbar-mobile');
    const topbar = document.getElementById('topbar');
    const toolbarHeight = toolbar ? toolbar.offsetHeight : 0;
    const topbarHeight = topbar ? topbar.offsetHeight : 0;
    return toolbarHeight + topbarHeight;
  };

  componentDidMount() {
    const query = getQuery();
    if (query.startdate && query.enddate && query.adult) {
      let { guests, arrivalDate, departureDate } = parseFormFromQueryString(query);
      if (guests && !Array.isArray(guests[0])) guests = [guests];
      this.setState({
        form: {
          ...this.state.form,
          guests,
          arrivalDate,
          departureDate
        },
        currentRoom: query.currentRoom,
        numberOfRooms: query.numberOfRooms,
        noSearch: false
      }, () => {
      this.updateCalendarAvailability(arrivalDate);
      });
    } else {
      this.updateCalendarAvailability();
    }
  }

  updateCalendarAvailability = (date) => {
    let dateToUseToGetCalendarAvailability = new Date();
    if (date && date > new Date()) {
      dateToUseToGetCalendarAvailability = date;
    }
    getCalendarAvailability({ id: this.supplier.integration_uuid, date: dateToUseToGetCalendarAvailability })
    .then(res => {
      this.setState({ availability: res.response })
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.form !== prevState.form) {
      this.updateAvailability();
    }
  }

  getLinkToSupplierPage = (supplier) => {
    let linkToSupplierPage = `/${getSupplierSlug(this.defaultLanguage, this.language, supplier.supplierType, supplier.supplier_slug.find(translation => translation.language.code === this.language).slug)}`;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("currentRoom", this.state.currentRoom + 1);
    const newSearch = searchParams.toString().replace("%2C", ",");;
    linkToSupplierPage += `?${newSearch}`;
    return linkToSupplierPage;
  }

  updateAvailability = () => {
    this.setState({ loading: true, prices: [], noSearch: false, errorOnSearch: false });
    getAvailability({ form: {...this.state.form, guests: this.state.currentRoom ? this.state.form.guests[this.state.currentRoom - 1] : this.state.form.guests[0] }, unitId: this.supplier.uuid, supplierId: this.props.pageContext.supplier.supplier_uuid })
    .then(res => {
      if (res && res.response && res.status === "ok") {
        const { prices  } = res.response;
        const availability = prices ? prices[0] : {};
        if (this.supplier.services && this.supplier.services.length) {
          availability.selected_services = availability.selected_services?.map(service => {
            const foundServiceOnSupplier = this.supplier.services.find(serv => parseInt(serv.service_uuid?.integration_uuid) === service.product_id);
            if (foundServiceOnSupplier) return { ...service, ...foundServiceOnSupplier.service_uuid }
            return service;
          })
        }
       
        availability.price = availability.price?.map(price => {
          return {
            ...price,
            amount: price.amount += availability.selected_services ? availability.selected_services.reduce((total, service) => total + service.price.price_value, 0) : 0
          }
        })
        let services = []
        if (this.supplier.services && this.supplier.services.length) {
          this.supplier.services.forEach(service => {
            if (!service.service_uuid) return;
            const thisServiceOnAvailability = availability.optional_services?.find(serv => { return serv.product_id === parseInt(service.service_uuid.integration_uuid) })
            if (service.service_uuid.scope === "package") return;
            if (thisServiceOnAvailability) {
              services.push({
                ...thisServiceOnAvailability,
                maxQuantity: thisServiceOnAvailability.quantity,
                quantity: 0,
                ...service.service_uuid
              })
            }
          })
        }
        this.setState({
          prices: {
            ...availability,
            services,
            complementary_products: availability.optional_services?.filter(service => service.required_value === true)
          },
          loading: false,
        }, () => {
          if (this.state.prices.price && this.state.prices.price[0]) {
            gtmFunction("view_item", [{ ...this.props.pageContext.supplier, price: this.state.prices.price[0] }])
          }
        })
      } else if (!res || res.status === "error") {
        this.setState({
          loading: false,
          errorOnSearch: true
        })
      }
    });
  }
  openServicesModal = ({ product }) => {
    this.setState({ servicesModal: true, servicesModalProduct: product })
  }

  checkForAddons = () => {
    if (this.state.prices.services && this.state.prices.services.length > 0) {
      this.openServicesModal({ product: this.state.prices })
    } else {
      this.addToCart();
    }
  }

  addToCart = () => {
    this.setState({ modalAddToCart: "loading" });
    addLodgingToCart({ 
      product: { 
        ...this.supplier, 
        supplier_uuid: this.props.pageContext.supplier.supplier_uuid 
      }, 
      price: this.state.selectedOffer, 
      form: {
        ...this.state.form, guests: this.state.currentRoom ? this.state.form.guests[this.state.currentRoom - 1] : this.state.form.guests[0] 
      }, 
      complementary_products: this.state.servicesModalProduct.complementary_products 
    })
    .then(() => {
      this.setState({ modalAddToCart: this.upselling ? "success" : "" }, () => {
        if(this.state.currentRoom === this.state.numberOfRooms || !this.state.numberOfRooms) return this.upselling ? null : navigate(this.moduleData.linkToCart);
        else navigate(this.getLinkToSupplierPage(this.supplier))
      });
    })
    .catch(() => this.setState({ modalAddToCart: "error" }))
  }

  closeServicesModal = ({ product = this.state.prices }) => {
    if(product){
      this.setState({ servicesModal: false, servicesModalProduct: product }, () => {
        this.addToCart();
      })
    }
    else {
      this.setState({servicesModal: false})
    }
  }

  togglePhotosModal = () => {
    this.setState({galleryModal: !this.state.galleryModal})
  }

  onMonthChange = (date) => {
    const dateAtTheStartOfTheMonth = new Date(date.setDate(1));
    this.updateCalendarAvailability(dateAtTheStartOfTheMonth);
  }

  updateDatesAndGuests = (arrivalDate = "", departureDate = "", guests = [], numberOfRooms) => {
    const searchParams = new URLSearchParams(window.location.search);
    const processedForm = processForm({ departureDate, arrivalDate, guests });
    for (const [key, value] of Object.entries(processedForm)) {
      if(key === "arrivalDate" && value) searchParams.set("startdate", value)
      if(key === "departureDate" && value) searchParams.set("enddate", value)
      if (key === "guests" && value) {
        if (Array.isArray(value)) {
          if (!processedForm.childages) searchParams.set("adult", value.join("-"));
          else {
            const adultString = value.map((val, index) => {
              if (processedForm.childages[index]) return val - processedForm.childages[index].split(",").length;
              return val;
            })
            searchParams.set("adult", adultString.join("-"))
          }
        } else {
          if(!processedForm.childages) searchParams.set("adult", value);
          else searchParams.set("adult", value - processedForm.childages.split(",").length);
        }
      }
      if(key === "childages") {
        if (Array.isArray(value)) {
          searchParams.set("childages", value.join("-") || "");
        } else {
          searchParams.set("childages", value || "");
        }
      }
    }
    if (numberOfRooms) searchParams.set("numberOfRooms", numberOfRooms);
    if (!searchParams.get("currentRoom") && numberOfRooms) searchParams.set("currentRoom", 1);
    const newSearch = searchParams.toString().replace("%2C", ",");;
    let newUrl = `${window.location.pathname}?${newSearch}`;
    if (numberOfRooms > 1 ) {
      newUrl = `/${getSupplierSlug(this.defaultLanguage, this.language, this.supplier.supplierType, this.supplier.supplier_slug.find(translation => translation.language.code === this.language).slug)}?${newSearch}`;
      navigate(newUrl);
      return;
    }
    window.history.replaceState(null, '', newUrl)
    this.setState({
      searchDrawer: false,
      form: {
        arrivalDate,
        departureDate,
        guests
      }
    })
  }

  getNumberOfPersons = () => {
    if (!this.state.currentRoom) return 0;
    let persons = this.state.form.guests[this.state.currentRoom - 1].length;
    return persons;
  }

  getNumberOfGuests = () => {
    let numberOfGuests = 0;
    if(this.state.numberOfRooms > 1){
      this.state.form.guests.forEach(guest => {
        numberOfGuests += guest.length
      })
    }
    else {
      numberOfGuests = this.state.form.guests.length ? this.state.form.guests[0].length : 0;
    }
    return numberOfGuests;
  }

  getTabs = () => {
    const tabs = [this.moduleData.roomsLabel, this.moduleData.descriptionLabel];
    if (this.props.pageContext.supplier.type === "cabin" && process.env.GATSBY_CONNECT_CLIENT === "tyinfilefjell") tabs[0] = this.moduleData.cabinsLabel;
    if (this.supplier?.features) tabs.push(this.moduleData.amenitiesLabel);
    if (this.supplier?.location) tabs.push(this.moduleData.locationLabel);
    if (this.supplier?.policies) tabs.push(this.moduleData.policiesLabel);
    return tabs;
  }

  render(){
    const { state, toggleSearchDrawer, changeTab, closeServicesModal, onMonthChange, getTabs, primaryButtonStyle, secondaryButtonStyle, supplier, language } = this;
    const { noSearch, form, currentTab, prices, searchDrawer, loading, availability, numberOfRooms } = state;
    const { images = [] } = supplier;
    const name = getLanguageField(supplier.translations, language, 'name');

    const textWhenNoResults = loading ? this.moduleData.searching : `${name} ${this.moduleData.noResultsLabel}`
    const pages = [{name: this.moduleData.searchResultLabel, current: false} , { name: getLanguageField(supplier?.translations, language, "name"), current: true}];
    if(supplier.type === "room") pages.splice(1, 0, { name: supplier.name.split("-")[0], current: false})
    const totalNights = form.arrivalDate && form.departureDate ? differenceInDays(form.arrivalDate, form.departureDate) : 0
    const persons = this.getNumberOfPersons();
    const numberOfGuests = this.getNumberOfGuests();
    const { max_adults, max_junior, max_stay, min_adults, min_junior, min_stay, junior_min_age, junior_max_age, blocked_days, blackout_periods, booking_anticipation_days, max_guests, translations, messaging } = getSearchFormConfiguration(this.props.pageContext.supplier);
    return (
      <ModuleWrapper className={`relative bg-gray-100 font-manrope`}>
        <main id="productPage" className={"max-w-7xl mx-auto lg:pt-4 min-h-screen"}
          style={{
              "--primaryColor": this.colors.primaryColor,
              "--secondaryColor": this.colors.secondaryColor,
          }}
        >
          <div className="bg-white rounded-t-2xl p-4 pb-0">
            <Breadcrumbs pages={pages}/>
          </div>
          {!noSearch
            ?
            <div className="lg:hidden sticky z-10 px-4 bg-white" style={{ top: this.getStickyOffset() }}>
              <SearchTopBar name={name} type={supplier.type} arrivalDate={form.arrivalDate} departureDate={form.departureDate} guests={numberOfGuests} onEditSearch={toggleSearchDrawer}/>
            </div>
            :
              <div id="mobileForm" className="lg:hidden bg-white">
              <SearchForm
                maxGuests={max_guests}
                searchFormTranslations={translations}
                type={supplier.type}
                language={language}
                availability={availability}
                arrivalDate={form.arrivalDate}
                departureDate={form.departureDate}
                guests={form.guests}
                loading={loading}
                _numberOfRooms={numberOfRooms}
                multiRoom={supplier.activate_multiple_room}
                maxRooms={supplier.max_multiple_rooms}
                onSearch={(_startDate, _endDate, _guests, numberOfRooms) => {
                  this.updateDatesAndGuests(_startDate, _endDate, _guests, numberOfRooms);
                }}
                onMonthChange={onMonthChange}
                minStay={min_stay}
                maxStay={max_stay}
                guestsTypes={{
                  min_adults,
                  min_junior,
                  max_adults,
                  max_junior,
                  junior_max_age,
                  junior_min_age
                }}
                weekDaysBlocked={blocked_days ? blocked_days : []}
                blackoutPeriods={blackout_periods}
                rangeInterval={[
                  new Date(new Date().setDate(new Date().getDate() + booking_anticipation_days)),
                  new Date().setFullYear(new Date().getFullYear() + 1)
                ]}
                messaging={messaging}
                errorOnSearch={this.state.errorOnSearch}
              />
            </div>
          }
          <div id="gallery" className="relative bg-white rounded-2xl p-6 rounded-t-none pt-0">
              <Swiper
                arrowClassName=""
                className="w-full h-64 lg:h-96 rounded-2xl"
                navigation={true}
                customNavigation
                customNavigationPrevClassName="absolute left-4 text-white bg-opacity-80 bg-black p-1 rounded-full z-[9] my-auto top-[108px] lg:top-[165px]"
                customNavigationNextClassName="absolute right-4 text-white bg-opacity-80 bg-black p-1 rounded-full z-[9] my-auto top-[108px] lg:top-[165px]"
                slidesPerView={1}
                spaceBetween={0}
                width={null}
              >
                {
                  images
                  .sort((a,b) => a.position - b.position)
                  .map((file, idx) => {
                    let path = `https://${getImageDeliveryUrl()}/`;
                    if (file.image) path += file.image.filename_disk;
                    if (file.directus_files_id) path += file.directus_files_id.filename_disk;
                    return <Image className="w-full h-full object-cover" src={path} key={`image-${idx}`}/>
                  })
                }
              </Swiper>
              <button
                className={`absolute bottom-10 right-10 z-[1] px-3 py-2 font-semibold text-sm rounded-lg min-w-max text-[color:var(--secondaryColor)] bg-[color:var(--primaryColor)]`}
                onClick={this.togglePhotosModal}
              >
                {this.moduleData.buttonOpenGalleryViewLabel} {supplier.images.length} {this.moduleData.buttonOpenGalleryPicturesLabel}
              </button>
            </div>

          <div className="lg:flex lg:gap-4 lg:py-4">
            <section id="unit" className="bg-white lg:w-8/12 rounded-2xl">
            {
              this.state.numberOfRooms > 1 ?
              <div className="p-4">
                <RoomSummarySelection
                  step={2}
                  persons={persons}
                  totalSteps={2}
                  nights={totalNights}
                  currentRoom={this.state.currentRoom}
                  language={this.language}
                />
              </div>
              : <div className="pt-6"/>
            }
              <header className="p-6 pb-0 pt-0">
                <span>{supplier.supplierName}</span>
                <h2 className="text-lg font-semibold">{name}</h2>
              </header>
              <LodgingTabs
                currentTab={currentTab}
                changeTab={changeTab}
                primaryButtonStyle={secondaryButtonStyle}
                baseURL={isRunTime() ? window.location.pathname : ""}
                tabs={getTabs()}
              />
              <div className="m-6 mt-0" id="Lodging Offers">
                <h3 className="text-lg font-bold mb-4">{this.moduleData.optionSelectionLabel}</h3>
                {
                  prices.price && prices.price.length ?
                  <div className="border-2 border-[#F4F4FA] rounded-2xl">
                    {
                      prices.price.map((offer => {
                        return (
                          <div className="p-4">
                            <LodgingCell
                              removeFrom
                              isHotel={false}
                              unit={{
                                name: offer.price_name,
                                id: offer.id,
                                price: [offer],//price renders first item of array
                                selectedServices: prices.selected_services
                              }}
                              language={language}
                              displayedLabel={this.moduleData.displayedLabel}
                            />
                            <button
                              onClick={() => this.setState({ selectedOffer: offer }, () => {
                                this.checkForAddons()
                              })}
                              className={`mt-4 w-full flex items-center justify-end border py-3 px-4 rounded-lg font-semibold ${primaryButtonStyle}`}
                            >
                              <span className="mx-auto block">{this.moduleData.bookLabel}</span>
                              <Icon icon="Plus" className="w-4" />
                            </button>
                          </div>
                        )
                      }))
                    }
                  </div>
                  : textWhenNoResults
                }
              </div>
              <div className="w-full h-[2px] bg-[#EAEAF2]" />
              <Description characters={300} title={this.moduleData.descriptionLabel} description={getLanguageField(supplier.translations, language, 'description', true)} buttonOpenText={this.moduleData.showLessButtonLabel} buttonClosedText={this.moduleData.showMoreButtonLabel} buttonStyle={this.secondaryButtonStyle} />
              {
                supplier.features && supplier.features.length ?
                  <>
                    <div className="w-full h-[2px] bg-[#EAEAF2]" />
                    <div className="p-6">
                      <Amenities title={this.moduleData.amenitiesLabel} language={language} amenities={supplier.features} buttonStyle={this.secondaryButtonStyle} buttonOpenText={this.moduleData.showLessButtonLabel} buttonClosedText={this.moduleData.showAllButtonLabel} />
                    </div>
                  </>
                : null
              }
              {
                supplier.location ?
                  <>
                    <div className="w-full h-[2px] bg-[#EAEAF2]" />
                    <Location title={this.moduleData.locationLabel} supplier={supplier} color={"#6D62E4"}/>
                  </>
                : null
              }
              {
                supplier.policies && supplier.policies.length ?
                  <>
                    <div className="w-full h-[2px] bg-[#EAEAF2]" />
                    <Policies title={this.moduleData.policiesLabel} language={language} policies={supplier.policies} buttonStyle={this.secondaryButtonStyle} buttonOpenText={this.moduleData.showLessButtonLabel} buttonClosedText={this.moduleData.showMoreButtonLabel} />
                  </>
                : null
              }
            </section>
            <aside id="sidebar" className={"hidden lg:flex lg:flex-col lg:w-4/12"}>
              <div id="form" className={"bg-white rounded-2xl"}>
                <SearchForm
                  maxGuests={max_guests}
                  searchFormTranslations={translations}
                  type={supplier.type}
                  colors={this.colors}
                  language={language}
                  availability={availability}
                  arrivalDate={form.arrivalDate}
                  departureDate={form.departureDate}
                  guests={form.guests}
                  loading={loading}
                  _numberOfRooms={numberOfRooms}
                  multiRoom={supplier.activate_multiple_room}
                  maxRooms={supplier.max_multiple_rooms}
                  onSearch={(_startDate, _endDate, _guests, numberOfRooms) => {
                    this.updateDatesAndGuests(_startDate, _endDate, _guests, numberOfRooms);
                  }}
                  onMonthChange={onMonthChange}
                  minStay={min_stay}
                  maxStay={max_stay}
                  guestsTypes={{
                    min_adults,
                    min_junior,
                    max_adults,
                    max_junior,
                    junior_max_age,
                    junior_min_age
                  }}
                  weekDaysBlocked={blocked_days ? blocked_days : []}
                  blackoutPeriods={blackout_periods}
                  rangeInterval={[
                    new Date(new Date().setDate(new Date().getDate() + booking_anticipation_days)),
                    new Date().setFullYear(new Date().getFullYear() + 1)
                  ]}
                  messaging={messaging}
                  errorOnSearch={this.state.errorOnSearch}
                  item={this.supplier}
                />
              </div>
            </aside>
          </div>
          <SearchModal
            type={supplier.type}
            arrivalDate={form.arrivalDate}
            departureDate={form.departureDate}
            guests={form.guests}
            open={searchDrawer}
            closeFn={toggleSearchDrawer}
            onSearch={(_startDate, _endDate, _guests, numberOfRooms) => {
              this.updateDatesAndGuests(_startDate, _endDate, _guests, numberOfRooms);
            }}
            availability={availability}
            onMonthChange={onMonthChange}
            _numberOfRooms={numberOfRooms}
            maxRooms={supplier.max_multiple_rooms}
            multiRoom={supplier.activate_multiple_room}
            minStay={min_stay}
            maxStay={max_stay}
            guestsTypes={{
              min_adults,
              min_junior,
              max_adults,
              max_junior,
              junior_max_age,
              junior_min_age
            }}
            weekDaysBlocked={blocked_days ? blocked_days : []}
            blackoutPeriods={blackout_periods}
            messaging={messaging}
            errorOnSearch={this.state.errorOnSearch}
            item={this.supplier}
          />
          {/* <Modal alignedCenter closeFn={() => this.setState({modalAddToCart: ""})} open={this.state.modalAddToCart === "adding"} title={<Icon icon="Info"/>} titleCentered>
            <div className="pb-6">
              <div className="text-center">

                {this.moduleData.modalAddTitle + " "}
                <strong>{name + " "}</strong>
                {this.moduleData.modalAddTitle2}
              </div>
              <button
                onClick={()=> this.setState({modalAddToCart: ""})}
                className="text-[color:var(--primaryColor)] border-[color:var(--secondaryColor)] mt-4 w-full flex items-center justify-end border py-3 px-4 rounded-3xl font-semibold"
              >
                <Icon icon="ArrowLeft" className="w-4 text-current" />
                <span className="mx-auto block">{this.moduleData.modalCtaBack}</span>
              </button>
              <button
                onClick={()=> this.addProductToCart()}
                className="text-[color:var(--secondaryColor)] bg-[color:var(--primaryColor)] mt-4 w-full flex items-center justify-end border py-3 px-4 rounded-3xl font-semibold"
              >
                <span className="mx-auto block">{this.moduleData.modalCtaAdd}</span>
                <Icon icon="Plus" className="w-4" />
              </button>
            </div>
          </Modal> */}
          {
            this.state.servicesModal ?
            <ServicesModal
              language={this.language}
              closeFn={closeServicesModal}
              product={this.state.servicesModalProduct}
              numberOfRooms={this.state.currentRoom}
              roomsTotal={this.state.numberOfRooms}
            />
            : null
          }

          <Modal hideCloseButton={true} alignedCenter closeFn={() => this.setState({modalAddToCart: ""})}
            open={this.state.modalAddToCart === "loading"}
            titleCentered
            >
            <div className="py-6 flex flex-col items-center gap-4">
              <Spinner />
              <span>{this.moduleData.addingToCart}</span>
            </div>
          </Modal>
          <Modal alignedCenter closeFn={() => this.setState({modalAddToCart: ""})}
            open={this.state.modalAddToCart === "error"}
            title={<Icon icon="Info" className="text-red-500" />}
            titleCentered
            >
            <div className="text-center mb-8">
              {this.moduleData.errorAdding}
            </div>
          </Modal>
          <UpsellingModal 
            closeFn={() => this.setState({ modalAddToCart: "" })}
            open={this.state.modalAddToCart === "success"} 
            upselling={this.upselling} 
            language={language}
            addedProductName={name} 
          />
          <GalleryModal closeFn={this.togglePhotosModal} images={images.filter(file => file.directus_files_id)} open={this.state.galleryModal} size="large" language={language}/>
        </main>
      </ModuleWrapper>
    )
  }
}

export const Head = ({ pageContext }) => {
  //Valid tags inside the Head function are: link, meta, style, title, base, script, and noscript.
  return (<>
  <HeadStyling layout={pageContext.layout} />
  <Seo data={pageContext.supplier} pageContext={pageContext} />
  </>);
}